const getTranslation = (id: string) => `content-manager.${id}`;

export { getTranslation };
